import React from 'react';
interface CTAButtonProps {
  showPrice?: boolean;
}
export const CTAButton = ({
  showPrice = false
}: CTAButtonProps) => {
  return <div className="text-center" data-id="element-15">
      <a href="https://nevaraquebec.com/products/kinepulse-masseur-4-en-1-qui-soulage-les-douleurs-neuropathiques" target="_blank" rel="noopener noreferrer" className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg text-xl transition duration-300 transform hover:scale-105" data-id="element-16">
        {showPrice ? 'COMMANDER MAINTENANT - 114.99$ SEULEMENT' : 'COMMANDER MAINTENANT'}
      </a>
      <div className="mt-4 flex items-center justify-center gap-4 text-sm text-gray-600 max-w-2xl mx-auto" data-id="element-17">
        <div className="flex items-center whitespace-nowrap" data-id="element-18">
          <div className="h-4 w-4 rounded-full bg-green-600 text-white flex items-center justify-center mr-2 flex-shrink-0 text-xs" data-id="element-19">
            ✓
          </div>
          <span data-id="element-20">30 jours garantis</span>
        </div>
        <div className="flex items-center whitespace-nowrap" data-id="element-21">
          <div className="h-4 w-4 rounded-full bg-green-600 text-white flex items-center justify-center mr-2 flex-shrink-0 text-xs" data-id="element-22">
            ✓
          </div>
          <span data-id="element-23">Support français</span>
        </div>
        <div className="flex items-center whitespace-nowrap" data-id="element-24">
          <div className="h-4 w-4 rounded-full bg-green-600 text-white flex items-center justify-center mr-2 flex-shrink-0 text-xs" data-id="element-25">
            ✓
          </div>
          <span data-id="element-26">Livraison rapide</span>
        </div>
      </div>
    </div>;
};